export default "__VITE_ASSET__DhxJlI5E__"